import PropTypes from "prop-types";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";

//redux
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import { useFormik } from "formik";
import * as Yup from "yup";

import { ToastContainer, toast } from "react-toastify";

// action
import { userForgetPassword, userResetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import { createSelector } from "reselect";
import ParticlesAuth from "./ParticlesAuth";
import { useEffect,useState } from "react";
import { resetResetPasswordFlag } from "slices/auth/forgetpwd/reducer";

const ResetPassword = (props: any) => {
  const dispatch: any = useDispatch();
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState<boolean>(false);

  useEffect(() => {
    dispatch(resetResetPasswordFlag());
  }, []);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: "",
      newpassword: "",
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Please Enter OTP"),
      username: Yup.string().required("Please Enter Username"),
      // token: Yup.string(),   //.required("Please Enter Reset Token"),
      newpassword: Yup.string().required("Please Enter New Password")  .min(8, "Password must be at least 8 characters")
  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
  .matches(/\d/, "Password must contain at least one digit")
  .matches(/[\W_]/, "Password must contain at least one special character (e.g., !@#$%^&*)"),
      // confirmpassword: Yup.string().oneOf([Yup.ref("newpassword")], "Password must match").required("Please Confirm New Password"),
    }),
    onSubmit: (values, { resetForm }) => {
      const payload = {
        ...values,
      };
      
      dispatch(userResetPassword(payload, props.router.navigate));
      //resetForm();
    },
  });

  const selectLayoutState = (state: any) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    forgetError: state.forgetError,
    forgetSuccessMsg: state.forgetSuccessMsg,
    resetSuccessMsg: state.resetSuccessMsg,
    resetError: state.resetError,
    userEmail: state.userEmail
  }));
  // Inside your component
  const { resetSuccessMsg, resetError, userEmail } = useSelector(selectLayoutProperties);

  useEffect(() => {
  if (resetSuccessMsg) {
    toast.success(resetSuccessMsg, {
      position: "top-right",
      hideProgressBar: false,
      className: "",
      progress: undefined,
      toastId: "reset-success",
    });
    setTimeout(() => {
      props.router.navigate("/login");
    }, 3000);
  }

  if (resetError) {
    toast.error(resetError, {
      position: "top-right",
      hideProgressBar: false,
      className: "bg-error fw-semibold",
      progress: undefined,
      toastId: "reset-error",
    });
  }
  }, [resetSuccessMsg,resetError]);

  document.title = "Forgot Password";
  return (
    <ParticlesAuth>
      <div className="auth-page-content d-flex justify-content-center align-items-center min-vh-100">
        <Container>
        {/* <ToastContainer autoClose={3000} limit={1} /> */}
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4 card-light">
                <CardBody className="p-4">
                  <div className="mx-2 mt-2">
                    <h5 className="text-primary">Reset your password</h5>
                    <p className="text-muted">Reset password with Amanat</p>
                    <div className="text-center">
                   <i className="ri-mail-send-line display-5 text-secondary mb-3"></i>
                    </div>
                  </div>

                  <Alert
                    className="border-0 alert-warning text-center mb-2 mx-2"
                    role="alert"
                  >
                    Please enter the OTP you received in your mailbox
                  </Alert>
                  <div className="p-2">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Enter Username</Label>
                        <Input
                          name="username"
                          className="form-control"
                          placeholder="Enter Username"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.username || ""}
                          invalid={
                            validation.touched.username && validation.errors.username
                              ? true
                              : false
                          }
                        />
                        {validation.touched.username && validation.errors.username ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.username}</div>
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-4">
                        <Label className="form-label">Enter OTP</Label>
                        <Input
                          name="otp"
                          className="form-control"
                          placeholder="Enter OTP"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.otp || ""}
                          invalid={
                            validation.touched.otp && validation.errors.otp
                              ? true
                              : false
                          }
                        />
                        {validation.touched.otp && validation.errors.otp ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.otp}</div>
                          </FormFeedback>
                        ) : null}
                      </div>
                       <div className="mb-4 ">
                        <Label className="form-label">New Password</Label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="newpassword"
                            className="form-control"
                            placeholder="Enter New Password"
                            type={passwordShow ? "text" : "password"}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.newpassword || ""}
                            invalid={
                              validation.touched.newpassword && validation.errors.newpassword
                                ? true
                                : false
                            }
                          />

                          {validation.touched.newpassword && validation.errors.newpassword && (
                            <FormFeedback type="invalid">
                              {validation.errors.newpassword}
                            </FormFeedback>
                          )}

                          <button
                            className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none text-muted"
                            type="button"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            {/* {passwordShow ? (
                              <i className="ri-eye-off-fill"></i>
                            ) : (
                              <i className="ri-eye-fill"></i>
                            )} */}
                          </button>
                        </div>
                      </div>
                       {/* <div className="mb-4">
                        <Label className="form-label">Confirm Pasword</Label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <Input
                            name="confirmpassword"
                            className="form-control"
                            placeholder="Confirm Password"
                            type={confirmPasswordShow ? "text" : "password"}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirmpassword || ""}
                            invalid={
                              validation.touched.confirmpassword && validation.errors.confirmpassword
                                ? true
                                : false
                            }
                          />
                          {validation.touched.confirmpassword && validation.errors.confirmpassword ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.confirmpassword}</div>
                            </FormFeedback>
                          ) : null}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                          >
                            <i className="ri-eye-fill align-middle"></i>
                          </button>
                        </div>
                      </div> */}

                      <div className="text-center mt-4">
                        <button className="btn btn-primary w-100" type="submit">
                          Submit
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Wait, I remember my password...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    {" "}
                    Click here{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ResetPassword.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ResetPassword);
